/*
* wehsoft Theme
*
* Use this file to add custom Javascript to wehsoft.  Keeping your custom
* Javascript in this fill will make it easier to update wehsoft. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line
  document.addEventListener('DOMContentLoaded', () => {
    const carrierDiv = document.getElementById('calc-carrier');

    // Only proceed if the element exists (product page)
    if (carrierDiv) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            // Find all span elements inside the calculator container
            const spans = carrierDiv.querySelectorAll('.ship-name span');

            spans.forEach(span => {
              const text = span.textContent.toLowerCase();
              // Check if it contains "dias úteis" (days) and hasn't been modified yet
              if (text.includes('dias úteis') && !text.includes('após o envio')) {
                span.textContent = span.textContent + ', após o envio do pedido';
              }
            });
          }
        });
      });

      // Observe changes in the container (child additions)
      observer.observe(carrierDiv, { childList: true, subtree: true });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
